import { HelpCircle } from "@untitledui/icons";

const SUPPORT_SITE_URL = "https://unbox.support.site/";

export function AccountMenuHelpCenter() {
  return (
    <a
      href={SUPPORT_SITE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="relative flex w-full flex-col overflow-hidden border-t border-secondary bg-unbox-cream-50 py-3 outline-focus-ring transition-colors hover:bg-unbox-cream-25 focus-visible:outline-2 focus-visible:-outline-offset-2"
    >
      <img
        src="/help-center-menu-banner.png"
        alt=""
        className="pointer-events-none absolute -top-5 left-[129px] h-[111px] w-[178px] max-w-none object-cover"
      />
      <div className="flex w-full items-center px-1.5">
        <div className="flex min-w-0 flex-1 items-start gap-2 rounded-md px-2 py-1.5">
          <HelpCircle aria-hidden="true" className="size-5 shrink-0 text-fg-quaternary" />
          <div className="flex flex-col items-start">
            <span className="text-sm font-semibold text-secondary">Help Center</span>
            <span className="max-w-[116px] text-xs font-medium text-tertiary">Quick answers to how Unbox works</span>
          </div>
        </div>
      </div>
    </a>
  );
}
